import { ServiceSteps } from '../features/product/product-slice';

export const orderServiceSteps = (steps: ServiceSteps[]): ServiceSteps[] => {
  const stepsOrder = steps.slice().sort((a: ServiceSteps, b: ServiceSteps) => {
    return a.service.order - b.service.order;
  });
  return stepsOrder;
};
